import React, { useState } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "reactstrap";
import { InfoOutlined } from "@mui/icons-material";

const MatchesEducation = ({ id = "matches-educational-tooltip", title = "Semáforo de matches" }) => {
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggle = () => setTooltipOpen(!tooltipOpen);

    return (
        <div className="matches-educational-container mb-3">
            <span className="counter-title">
                {title}
                <span
                    id={id}
                    className="info-icon ml-2"
                    style={{ cursor: "pointer", color: "#1976d2" }}
                >
                    <InfoOutlined className="icon-matches" />
                </span>
                <Tooltip
                    placement="bottom"
                    isOpen={tooltipOpen}
                    target={id}
                    toggle={toggle}
                    className="custom-tooltip"
                >
                    <div className="tooltip-content p-3">
                        <div className="mb-2">
                            Filtra tus productos por precio. Este semáforo se
                            basa en al menos una coincidencia en las tiendas de
                            tus competidores de productos idénticos y
                            comparables con stock.
                        </div>
                        <div className="mb-2">
                            ¿En qué horarios se actualizan los matches
                            (coincidencias)?
                        </div>
                        <div>Productos con match y con stock</div>
                        <table>
                            <tbody>
                                <tr>
                                    <td className="matches-and-stock-table">
                                        09:00, 11:00, 14:00 y 16:00
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div>Productos sin stock</div>
                        <table>
                            <tbody>
                                <tr>
                                    <td className="matches-and-stock-table">
                                        0 a 1 día
                                    </td>
                                    <td className="matches-and-stock-table">
                                        11:00 y 16:00
                                    </td>
                                </tr>
                                <tr>
                                    <td className="matches-and-stock-table">
                                        0 a 4 días
                                    </td>
                                    <td className="matches-and-stock-table">
                                        05:00
                                    </td>
                                </tr>
                                <tr>
                                    <td className="matches-and-stock-table">
                                        2 a 10 días
                                    </td>
                                    <td className="matches-and-stock-table">
                                        05:00
                                    </td>
                                </tr>
                                <tr>
                                    <td className="matches-and-stock-table">
                                        11 a 30 días
                                    </td>
                                    <td className="matches-and-stock-table">
                                        domingos, martes y jueves a las 18:30
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Tooltip>
            </span>
        </div>
    );
};

MatchesEducation.propTypes = {
    id: PropTypes.string,
};

export default MatchesEducation;
